import { useState } from 'react';

import { NavItem } from 'types';

import { useNavData } from 'hooks/useNavData';

import { Dropdown } from 'components/Dropdown';

import * as S from './Nav.styles';

const useNav = () => {
  const [isSearch, isSearchSet] = useState(false);

  const navData = useNavData();

  const navDataMapped = navData?.map((item: NavItem) => (
    <S.Li
      hidden={item.hidden}
      $fullWidth={Boolean(item.list && item.list.length > 5)}
      key={item.label}
    >
      {item.list ? (
        <Dropdown
          scale="s"
          itemMotive="dropdownMenu"
          labelMotive="menuLink"
          hasAnimation
          label={item.label}
          items={item.list}
          emptyMessage={item.emptyMessage}
        />
      ) : (
        item.to && (
          <S.NavButton fontFamily="LFT Zeno" scale="s" asLink to={item.to}>
            {item.label}
          </S.NavButton>
        )
      )}
    </S.Li>
  ));

  return {
    navDataMapped,
    isSearch,
    isSearchSet,
  };
};

export { useNav };
